<template>
  <div  class="yjpzHome">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="display: flex"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="省份:">
            <el-select filterable v-model="formInline.xzqhId" placeholder="请选择">
              <el-option
                v-for="item in xzqhList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预警类型:">
            <el-select v-model="formInline.yjlx" placeholder="请选择">
              <el-option
                v-for="item in yjlxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公安预警:">
            <el-select v-model="formInline.sfkq" placeholder="请选择">
              <el-option
                v-for="item in kqztList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提前预警:">
            <el-select v-model="formInline.tqyjSfkq" placeholder="请选择">
              <el-option
                v-for="item in kqztList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="width: 200px">
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              size="small"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh-left"
              round
              size="small"
              @click="resetDataSource"
            >重置</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;">
      <div class="tablemes">
        <el-table
          ref="yjpzTable"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="xzqhName"
            label="省份"
            />
          <el-table-column
            prop="yjlxLabel"
            label="预警类型"
            />
          <el-table-column
            label="公安预警开启状态"
          >
            <template slot-scope="scope">
              <span
                :style="
                  scope.row.sfkqLabel == '关闭'
                    ? 'color:red '
                    : ''
                "
              > 已{{scope.row.sfkqLabel}}</span>
              <el-switch
                v-model="scope.row.sfkq"
                :width="60"
                active-value="1"
                inactive-value="0"
                :class="{
                    'switch-is-actived': scope.row.sfkq == '1',
                  }"
                @change="gayjChangeKqzt(scope.row, $event)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="提前预警开启状态"
          >
            <template slot-scope="scope" >
              <span
                :style="
                  scope.row.tqyjSfkqLabel == '关闭'
                    ? 'color:red '
                    : ''
                "
              >已{{scope.row.tqyjSfkqLabel}}</span>
              <el-switch
                v-model="scope.row.tqyjSfkq"
                :width="60"
                active-value="1"
                inactive-value="0"
                :class="{
                    'switch-is-actived': scope.row.tqyjSfkq == '1',
                  }"
                @change="tqyjChangeKqzt(scope.row, $event)"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {getkv} from "@/assets/js/common";
import {getList,changeStatusPut,changeStatusTqyjPut} from "@/assets/js/yjpz";
import {getXZQHList} from "@/assets/js/xzqh";

export default {
  name:'YjczPz',
  data(){
    return {
      formInline: { // 搜索表单
        xzqhId: '',
        yjlx: '',
        sfkq: '',
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      tableData: [], // 表格数据
      yjlxList: [],
      xzqhList: [],
      kqztList:[
        {
          label: '关闭',
          value: '0'
        },
        {
          label: '开启',
          value: '1'
        }
      ],
    }
  },
  mounted() {
    getkv('yzd_yjcz_yjlx').then((e) => {
      this.yjlxList = e.data.data
    })
    getXZQHList({
      param: {}
    }).then(res => {
      if (res.status === 200 && res.data.code === '000000') {
        this.xzqhList = []
        let sj = res.data.data
        sj.forEach((elem, index) => {
           let obj = {label:elem.areaName,value:elem.xzqhId}
           this.xzqhList.push(obj)
          });
      }
    })
    this.loadDatasource()
  },
  methods:{
    gayjChangeKqzt(row, status) {
      let ztLabel = '开启'
      if(status == '0'){
        row.sfkq = '1'
        ztLabel = '关闭'
      }else{
        row.sfkq = '0'
      }
      this.$confirm('确定'+ztLabel+'这条公安预警吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatusPut(status,row.id).then((res) => {
          if(res.status === 200 && res.data.code === '000000'){
            this.loadDatasource()
            this.$message.success('操作成功!')
          }
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    tqyjChangeKqzt(row, status) {
      let ztLabel = '开启'
      if(status == '0'){
        row.tqyjSfkq = '1'
        ztLabel = '关闭'
      }else{
        row.tqyjSfkq = '0'
      }
      this.$confirm('确定'+ztLabel+'这条提前预警吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatusTqyjPut(status,row.id).then((res) => {
          this.loadDatasource()
          this.$message.success('操作成功!')
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 查询列表数据
    loadDatasource() {
      getList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        xzqhId: '',
        yjlx: '',
        sfkq: '',
      }
      this.loadDatasource()
    },
    //修改数据状态
    changeStatus(kqzt,id){

    }
  }
}
</script>

<style scoped lang='less'>
  .yjpzHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
        &:last-child {
          width: 90px;
          height: 39px;
          /deep/ .el-button {
            width: 90px !important;
            height: 39px;
            border-radius: 3px;
          }
        }
      }
    }
    .sousuo {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
      .sousuoButton {
        width: 90px;
        height: 39px;
        background: #4170ff;
        border-color: #4170ff;
      }
      .chongzhiButton {
        width: 90px;
        height: 39px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
